const promises = [
  {
    label: "Problem-first",
    text: "We choose the technology after we understand the challenge.",
  },
  {
    label: "Built visibly",
    text: "You review the product as it takes shape—not at the end.",
  },
  {
    label: "Evidence-led",
    text: "You leave with a working first version and a clearer next move.",
  },
];

const BuildPromiseStrip = () => {
  return (
    <div className="apl-promise-strip">
      <div className="apl-shell apl-promise-grid">
        {promises.map((promise) => (
          <div className="apl-promise" key={promise.label}>
            <small>{promise.label}</small>
            <strong>{promise.text}</strong>
          </div>
        ))}
      </div>
    </div>
  );
};

export default BuildPromiseStrip;
